import { Propiedades } from "../models/Propiedades";
import { EncontrarInmuebles } from "../models/EncontrarInmuebles";
import {
    ArgentinaJersey,
    AudioPlayer,
    ChineseAstrology,
    CorporateLanding,
    CurrencyBond,
    DebatesFaq,
    Dialogues,
    DrawFifaWorldCup,
    Elections,
    Forecast,
    FrequentlyAskedQuestions,
    Games,
    GridGame,
    Holiday,
    HelpCenter,
    Joke,
    LandingApp,
    LandingDemocraciayDesarrollo,
    LandingEMQV,
    Lottery,
    Movil,
    Newsletter,
    Olympics,
    RadioLive,
    Results,
    Rss,
    RuralWeather,
    Searcher,
    Service,
    SiteMap as Mapa,
    SportsCalendar,
    Tags,
    TermsConditions,
    VideoDocumentary,
    Weather,
    WesternAstrology,
    Tasador,
    WorldCupTrivia,
    BuildYourTeam,
    GuiaMundial,
    WorldcupSimulator,
    SpaceDebat
} from "models";

const listOfClass = {
    "buscador": Searcher,
    "claringrilla": GridGame,
    "clima": Weather,
    "deportes": SportsCalendar,
    "debates": SpaceDebat,
    "dialogos": Dialogues,
    "economia": CurrencyBond,
    "feriados": Holiday,
    "horoscopo": WesternAstrology,
    "horoscopo-chino": ChineseAstrology,
    "humor": Joke,
    "landingapp": LandingApp,
    "juegos": Games,
    "loterias-y-quinielas": Lottery,
    "newsletter": Newsletter,
    "newsletters": Newsletter,
    "preguntas-frecuentes": FrequentlyAskedQuestions,
    "centro-de-ayuda.html": HelpCenter,
    "radio-mitre-vivo": RadioLive,
    "rural": RuralWeather,
    "temas": Tags,
    "videos-documentales-clarin": VideoDocumentary,
    "mapa-del-sitio": Mapa,
    "ayuda": TermsConditions,
    "rss.html": Rss,
    "movil.html": Movil,
    "elecciones": Elections,
    "Elmundoqueviene": LandingEMQV,
    "DemocraciayDesarrollo": LandingDemocraciayDesarrollo,
    "suscripciones": CorporateLanding,
    "juegos-olimpicos": Olympics,
    "playlist": AudioPlayer,
    "pronostico-mundial-clubes-2025": Forecast,
    "pronostico-mundial-2026": DrawFifaWorldCup,
    "tasador": Tasador,
    "el-mundialista": WorldCupTrivia,
    "camiseta-argentina-mundiales": ArgentinaJersey,
    "simulador-mundial": WorldcupSimulator,
}
export const getServiceData = async (query, menu) => {
    let service;
    const matchStr = query?.match?.[0] ?? "";

    if (matchStr.startsWith("arma-tu-equipo-")) {
        service = new BuildYourTeam();
    } else if (
        matchStr === "guia-completa-mundial-2026" ||
        matchStr.startsWith("guia-completa-mundial-2026/")
    ) {
        service = new GuiaMundial();
    } else if (
        matchStr === "propiedades" && query?.match?.[1] === "calculadora-alquileres"
    ) {
        service = new Propiedades();
    } else if (
        matchStr === "propiedades" && query?.match?.[1] === "encontrar-inmuebles"
    ) {
        service = new EncontrarInmuebles();
    } else if (
        matchStr === "propiedades" && query?.match?.[1] === "valor-propiedad"
    ) {
        service = new Tasador();
    } else if (
        matchStr === "debates" && query?.match?.[1] === "preguntas-frecuentes"
    ) {
        service = new DebatesFaq();
    } else if (
        matchStr === "deportes" && query?.match?.[1] === "estadisticas"
    ) {
        service = new Results();
    } else if (listOfClass[matchStr]) {
        service = new listOfClass[matchStr];
    } else {
        service = new Service({});
    }
    await service.parseData(query.match, menu, query);
    return service;
}